import { render, staticRenderFns } from "./HCPTraining.vue?vue&type=template&id=5224ff7b"
import script from "./HCPTraining.vue?vue&type=script&lang=js"
export * from "./HCPTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports